import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const misskey = defineConnector({
  identifier: "misskey",
  name: "Misskey",
  tagLine: "Decentralized social networking platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Misskey access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Misskey instance, go to **Settings → API** and generate a new access token.",
        },
      ],
    },
    {
      title: "Enter your details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://misskey.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Misskey instance.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => ({
      url: `${instanceUrl}/api/i`,
      expectedStatus: 200,
    }),
  },
});
